// extracted by mini-css-extract-plugin
export default {"quillEditor":"quillEditor_quillEditor__rwVQ2"};